import React from 'react';

const ContaBancariaContext = React.createContext();

export default ContaBancariaContext;
